<template>
  <CustomPage title="领券中心" style="background: #f7f7f7">
    <div slot="content" style="height: 100%">
      <div class="allContent">
        <div class="downPullText">
          <span @click="showCouponRange = true">
            <span>{{ rangeText }} </span
            ><Icon name="arrow-down" color="#808080" size="6"
          /></span>
        </div>

        <div class="coupon-container">
          <!-- //各种类型优惠券 -->
          <template v-if="Object.keys(couponList).length > 0">
            <welfareTicketContent
              v-for="(value, keyVaule) in couponList"
              :key="keyVaule"
              :type="keyVaule"
              :ticketArr="value"
            >
              <div slot="ticketContent">
                <div
                  class="overflow-y-auto"
                  style="max-height: calc(100vh - 120px)"
                >
                  <div
                    v-for="(item, index) in value[1]"
                    :key="index"
                    class="
                      rounded-lg
                      overflow-hidden
                      lightshadow
                      flex flex-row
                      text-white
                      items-center
                      justify-between
                      h-24
                      ticketItemBottom
                    "
                    :style="{
                      backgroundColor:
                        item.relationType === 'activity' ||
                        item.relationType === 'goods'
                          ? '#fff4f4'
                          : item.relationType === 'all'
                          ? '#ffdada'
                          : item.relationType === 'brand'
                          ? '#fff3de'
                          : null,
                    }"
                  >
                    <div style="width: 150px" class="ticketItemLeft">
                      <div>
                        <span class="text-xl">¥</span
                        ><span
                          class="leading-10 font-semibold"
                          style="letter-spacing: 0.1rem; font-size: 2.5rem"
                          >{{ item.faceValue }}</span
                        >
                      </div>
                      <div class="text-xs">
                        满{{ item.threshold ? item.threshold : "任意" }}元可用
                      </div>
                    </div>
                    <div class="text-left flex-grow ml-3">
                      <div class="text-black text-sm mb-1">
                        {{ item.couponName }}
                      </div>
                      <div class="text-xs">
                        {{ item.startDate }} - {{ item.endDate }}
                      </div>
                    </div>

                    <div class="ticketRight">
                      <div class="differentRangeTicket">
                        <span>{{
                          item.relationType === "activity"
                            ? "活动券"
                            : item.relationType === "goods"
                            ? "商品券"
                            : item.relationType === "all"
                            ? "平台福利券"
                            : item.relationType === "brand"
                            ? "品牌券"
                            : null
                        }}</span>
                      </div>

                      <Button
                        v-if="item.remainNum == 0"
                        disabled
                        class="w-12 self-end flex-shrink-0"
                        style="
                          padding-left: 6px;
                          padding-right: 6px;
                          margin-bottom: 1rem;
                          margin-right: 0.75rem;
                          white-space: nowrap;
                        "
                        type="danger"
                        round
                        color="#808080"
                        size="mini"
                        >已领完</Button
                      >

                      <Button
                        v-else-if="
                          item.getstatus !== 'got' &&
                          !item.isClaim &&
                          item.remainNum > 0
                        "
                        class="w-12 self-end flex-shrink-0"
                        style="
                          padding-left: 6px;
                          padding-right: 6px;
                          margin-bottom: 1rem;
                          margin-right: 0.75rem;
                        "
                        type="danger"
                        round
                        plain
                        color="red"
                        size="mini"
                        @click="getCoupon(item)"
                        >领取</Button
                      >

                      <Button
                        v-else
                        disabled
                        class="w-12 self-end flex-shrink-0"
                        style="
                          padding-left: 6px;

                          margin-bottom: 1rem;
                          margin-right: 0.75rem;
                        "
                        type="danger"
                        round
                        plain
                        color="red"
                        size="mini"
                        >已领取</Button
                      >
                    </div>
                  </div>
                </div>
              </div></welfareTicketContent
            ></template
          >

          <Button
            round
            style="background: #e89a52; width: 80%; margin: 0 10%"
            size="large"
            @click="$router.push({ name: 'Coupon' })"
            ><span class="text-white">查看我的优惠券</span></Button
          >
        </div>
      </div>

      <!-- //各种类型弹框 -->
      <ActionSheet
        v-model="showCouponRange"
        title="类型"
        :closeable="false"
        class="rangeDialog"
      >
        <div class="m-3 overflow-y-auto" style="max-height: 21rem">
          <Row gutter="20" style="margin-bottom: 10px">
            <Col span="12"
              ><div
                class="typeBorder"
                :class="{ activeTypeBorder: rangeText === '全部类型' }"
                @click="selectedType('全部类型')"
              >
                全部类型{{
                  rangeText === "全部类型" ? "(" + allRangeLength + ")" : ""
                }}
              </div></Col
            >
            <Col span="12">
              <div
                class="typeBorder"
                :class="{ activeTypeBorder: rangeText === '活动优惠券' }"
                @click="selectedType('活动优惠券')"
              >
                活动优惠券{{
                  rangeText === "活动优惠券" ? "(" + activityLength + ")" : ""
                }}
              </div></Col
            >
          </Row>
          <Row gutter="20" style="margin-bottom: 10px">
            <Col span="12"
              ><div
                class="typeBorder"
                :class="{ activeTypeBorder: rangeText === '全平台福利' }"
                @click="selectedType('全平台福利')"
              >
                全平台福利{{
                  rangeText === "全平台福利" ? "(" + allPlatLength + ")" : ""
                }}
              </div></Col
            >
            <Col span="12">
              <div
                class="typeBorder"
                :class="{ activeTypeBorder: rangeText === '品牌优惠券' }"
                @click="selectedType('品牌优惠券')"
              >
                品牌优惠券{{
                  rangeText === "品牌优惠券" ? "(" + brandLength + ")" : ""
                }}
              </div></Col
            >
          </Row>
        </div>
        <div class="mx-3 mb-3">
          <Button
            style="padding-left: 12px; padding-right: 12px"
            round
            plain
            color="#e82035"
            size="large"
            @click="showCouponRange = false"
            >关闭</Button
          >
        </div>
      </ActionSheet>
    </div>
  </CustomPage>
</template>

<script>
import CustomPage from "@/components/custom-page.vue";
import { getCouponCenter, getCoupon } from "./webApi";
import { Button, Toast, Icon, ActionSheet, Col, Row } from "vant";
import welfareTicketContent from "@/components/welfareTicketContent";
export default {
  components: {
    CustomPage,
    Button,
    Icon,
    ActionSheet,
    Col,
    Row,
    welfareTicketContent,
  },

  watch: {
    rangeText(val) {
      console.log("-----切换到-----" + val);
      let msg;
      if (val === "全部类型") {
        msg = { ...this.activityData, ...this.brandData, ...this.allPlatData };
      } else if (val === "活动优惠券") {
        msg = this.activityData;
      } else if (val === "全平台福利") {
        msg = this.allPlatData;
      } else if (val === "品牌优惠券") {
        msg = this.brandData;
      }

      this.couponList = msg;
    },
  },
  computed: {
    allPlatLength() {
      if (Object.keys(this.allPlatData).length > 0) {
        return this.allPlatData.all[1] ? this.allPlatData.all[1].length : 0;
      }
      return 0;
    },
    activityLength() {
      let sum = 0;
      if (Object.keys(this.activityData).length > 0) {
        for (const item in this.activityData) {
          if (this.activityData[item][1]) {
            sum += this.activityData[item][1].length;
          }
        }
      }
      return sum;
    },

    brandLength() {
      let sum = 0;
      if (Object.keys(this.brandData).length > 0) {
        for (const item in this.brandData) {
          if (this.brandData[item][1]) {
            sum += this.brandData[item][1].length;
          }
        }
      }
      return sum;
    },
    allRangeLength() {
      let sum = 0;
      if (Object.keys(this.couponList).length > 0) {
        for (const item in this.couponList) {
          if (this.couponList[item][1]) {
            sum += this.couponList[item][1].length;
          }
        }
      }
      return sum;
    },
  },
  data() {
    return {
      couponList: {},
      showCouponRange: false,
      rangeText: "全部类型",
      activityData: {},
      brandData: {},
      allPlatData: {},
    };
  },
  created() {
    getCouponCenter({ relationType: null }).then(({ data }) => {
      console.log("getCouponCenter", data);

      // const c = { all: [null, []], a1: ['img', []], a2: ['img', []] }
      const activityData = {};
      const brandData = {};
      const allPlatData = {};
      if (data && data.length > 0) {
        data.map((item) => {
          const activitylArr = [];

          if (item.relationType === "activity") {
            activitylArr[1] = item.coupons;
            activitylArr[0] = item.actBannerImg;

            activityData[item.actName] = activitylArr;
            this.activityData = activityData;
          } else if (item.relationType === "brand") {
            activitylArr[1] = item.coupons;
            activitylArr[0] = item.brandImg;

            brandData[item.brandName] = activitylArr;
            this.brandData = brandData;
          } else if (item.relationType === "all") {
            activitylArr[1] = item.coupons;
            activitylArr[0] = null;

            allPlatData.all = activitylArr;
            this.allPlatData = allPlatData;
          }
        });
        // console.log(
        //   '----this.activityData----',
        //   this.activityData,
        //   '----this.brandData----',
        //   this.brandData,
        //   '----this.allPlatData----',
        //   this.allPlatData
        // )
        this.couponList = { ...activityData, ...brandData, ...allPlatData };
      }
    });
  },
  methods: {
    getCoupon(item) {
      getCoupon(item.couponId).then((res) => {
        Toast({
          message: res.message,
          position: "center",
          duration: 1000,
        });
        this.$set(item, "getstatus", "got");
        this.$set(item, "remainNum", item.remainNum - 1);
      });
    },

    selectedType(type) {
      // alert('类型')

      this.rangeText = type;
      this.showCouponRange = false;
    },
  },
};
</script>

<style lang="less" scoped>
.active {
  background-color: #d8283b !important;
  color: #fff;
}

.allContent {
  .downPullText {
    margin: 24px 0 0 24px;
    font-size: 28px;
    color: #808080;
  }

  .ticketItemBottom {
    margin-bottom: 20px;
    padding-left: 40px;
    color: #e82035;
    &:nth-last-child(1) {
      margin-bottom: 0px;
    }

    .ticketItemLeft {
      .moneySymbol {
        margin-right: 4px;
      }
    }

    .ticketRight {
      height: 100%;
      .differentRangeTicket {
        width: 140px;
        height: 32px;
        background: #ffe3e6;
        border-radius: 0px 12px 0px 12px;
        margin-bottom: 16px;
        font-size: 22px;
        text-align: center;
      }
    }
  }
}

.rangeDialog {
  .typeBorder {
    height: 68px;
    border-radius: 16px;
    border: 2px solid #cfcfcf;
    color: #cfcfcf;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    &.activeTypeBorder {
      border: 2px solid #e82035;
      color: #e82035;
    }
  }
}
</style>
